import ContainerService from './apiclients/ContainerService';
import FileDeliveryService from './apiclients/FileDeliveryService';
import IdentityService from './apiclients/IdentityService';
import ConfigurationService from './apiclients/ConfigurationService';
import StoreController from '@projeccions-pdc/frontend-storage';
import { userBelongsToPlatform } from './helpers';
import AppContext from './AppContext';

class AppController {
    static loadPlatformAndUserData = async () => {
        // console.log('from loadPlatformAndUserData')
        let appContext = new AppContext();
        let myPlatforms = appContext.getMyPlatforms();

        // let newState = {};
        let myInfo = await AppController.getMyInfo();
        // newState.myInfo = myInfo;
        appContext.setMyInfo(myInfo);

        let newMyPlatforms = myPlatforms;
        // if (!myPlatforms) {
        newMyPlatforms = await AppController.getMyPlatforms();
        // }
        appContext.setMyPlatforms(newMyPlatforms);

        let canUsePlatform = AppController.updateCanUsePlatform();
        // newState.canUsePlatform = canUsePlatform;
        appContext.setCanUsePlatform(canUsePlatform);

        // return newState;
    };

    static refreshMyPlatforms = async () => {
        let myPlatforms = await AppController.getMyPlatforms();
        let canUsePlatform = AppController.updateCanUsePlatform();
        return { myPlatforms, canUsePlatform };
    };

    static updateCanUsePlatform = () => {
        let canUsePlatform = true;
        if (!userBelongsToPlatform()) {
            canUsePlatform = false;
        }
        return canUsePlatform;
    };

    static refreshPlatformConfig = async (newPlatformId) => {
        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();

        if (newPlatformId) {
            platformId = newPlatformId;
        }

        let platformConfig = {};

        let _StoreController = new StoreController(platformId, '');

        try {
            platformConfig = await ConfigurationService.getPlatformConfiguration();
            _StoreController.set('platformConfig', platformConfig);
        } catch (err) {
            platformConfig = _StoreController.get('platformConfig');
        }

        if (!platformConfig) platformConfig = {};

        // let corporateColors = [];
        // if (platformConfig && platformConfig.customStyles) {
        //     Object.keys(platformConfig.customStyles).forEach(key => {
        //         if (
        //             platformConfig.customStyles[key].indexOf('#') > -1 &&
        //             corporateColors.indexOf(platformConfig.customStyles[key]) === -1
        //         ) {
        //             corporateColors.push(platformConfig.customStyles[key]);
        //         }
        //     });
        // }
        // platformConfig.corporateColors = corporateColors;
        // if (!platformConfig.corporateIcons) platformConfig.corporateIcons = [];

        appContext.setPlatformConfig(platformConfig);

        return platformConfig;
    };

    static getPlatformConfig = async (config, platformId) => {
        try {
            let data = await ConfigurationService.getPlatformConfiguration();
            return data;
        } catch (err) {
            return {};
        }
    };

    static getMyInfo = async () => {
        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let _StoreController = new StoreController(platformId, '');
        try {
            // console.log('getMyInfo')
            let data = await IdentityService.getMyInfo();
            _StoreController.set('myInfo', data);
            return data;
        } catch (err) {
            console.log(err.message, err);
            return _StoreController.get('myInfo');
        }
    };

    static getMyPlatforms = async () => {
        let _StoreControllerNoPlatform = new StoreController('', '');
        try {
            // console.log('getMyPlatforms')
            let data = await IdentityService.getMyPlatforms();
            _StoreControllerNoPlatform.set('myPlatforms', data);
            return data;
        } catch (err) {
            console.log('getMyPlatforms', err, err.message);
            return _StoreControllerNoPlatform.get('myPlatforms');
        }
    };

    static updateContainerAppConfig = () => {
        return ContainerService.configContainer().catch((err) => {
            console.log(err.message);
        });
    };

    static getOnlineStatus = async () => {
        try {
            let response = await ContainerService.getOnlineStatus();
            console.log('getOnlineStatus', response);
            return response;
        } catch (err) {
            console.log(err.message);
            return {
                isOnline: true,
            };
        }
    };

    static isContainerCapable = async (fileId) => {
        try {
            let response = {
                isCapable: false,
                contentType: undefined,
            };
            if (process.env.REACT_APP_IS_CONTAINER === 'true') {
                response = await ContainerService.containerIsCapable(fileId);
                console.log('isContainerCapable', response);
            }

            return response;
        } catch (err) {
            console.log('isContainerCapable err', err.message);
        }
    };

    static openFileInContainer = (fileId) => {
        return ContainerService.openFileInContainer(fileId)
            .then((data) => {
                //TODO: pensar resposta en cas de no poder obrir-lo nativament
                console.log('openFileInContainer', data);
            })
            .catch((err) => {
                console.log('openFileInContainer err', err.message);
            });
    };

    static openLinkInContainer = (data) => {
        let body;
        if (typeof data === 'object') {
            body = {
                ...data.links,
            };
        } else {
            body = {
                url: data,
            };
        }

        return ContainerService.openLinkInContainer(body)
            .then((data) => {
                //TODO: pensar resposta en cas de no poder obrir-lo nativament
                console.log('openFileInContainer', data);
            })
            .catch((err) => {
                console.log('openFileInContainer err', err.message);
            });
    };

    static getFileContentType = async (fileId, urlModifier) => {
        try {
            let urlType = 'get';
            if (urlModifier) {
                urlType = urlModifier;
            }
            let response = await FileDeliveryService.getFileContentType(fileId, urlType);
            //console.log('getFileContentType', response)
            if (response.headers) {
                let contentType = response.headers.get('content-type');
                if (contentType !== undefined && contentType.indexOf(',') !== -1) {
                    let aux = contentType.split(',');
                    contentType = aux[0];
                }
                //console.log('getFileContentType', contentType);
                return contentType;
            } else {
                return 'unknown';
            }
        } catch (err) {
            console.log(err.message);
            //console.log('getFileContentType error', err)
        }
    };

    static requestAccessToPlatform = async () => {
        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        try {
            await IdentityService.requestAccessToPlatform(platformId);
            return true;
        } catch (err) {
            console.log(err.message, err);
            return false;
        }
    };
}

export default AppController;
